import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import SliderWrapper from "jd-library/SliderWrapper";
import SliderHeader from "jd-library/SliderHeader";
import historyHandler from "jd-library/historyHandler";
import SearchText from 'jd-library/SearchText';
import withRipple from 'jd-library/withRipple';
import toastMessageActions from 'jd-library/toastMessageActions';
import FullWidthButton from 'jd-library/FullWidthButton';
import FormCheck from 'jd-library/FormCheck';
import AddNewSupplier  from "jd-library/AddNewSupplier";
import axios from 'axios';
import style from "./select_supplier_slider.scss";
const SelectSupplierSlider = props => {
    const { onHidden, addedSuppliers, addedSupplierIds, supplierId, onContinue } = props;
    const [searchLoader, setSearchLoader] = useState(false);
    const [addSlider, toggleAddSlider] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const[debounceTimeout, setDebTimeout] = useState('');
    const[searchVal, setSearchVal] = useState('');
    const[activeTab, setActiveTab] = useState(addedSuppliers.length ? 1 : 0);
    const[supplierList, setSupplierList] = useState(addedSuppliers);
    const[supplierIdsList, setSupplierIdsList] = useState(addedSupplierIds);
    const onFooterBtnClick = () => {
        var data = {
            supKeys: supplierIdsList,
            supData: supplierList
        };
        onContinue(data);
        historyHandler.closeCurrent();
    }
    const sliderProps = {
        slider: {
            className: style['select-supplier-slider']
        },
        footer: {
			fullWidthBtn: {
				className: style['select-supplier-footer'],
				onClick: onFooterBtnClick,
				children: (
					<>
						<FullWidthButton.Section
							variant='left'
							text={supplierList.length+' Supplier(s) Selected'}
						/>
						<FullWidthButton.Section
							iconClass={`continue-icon ${style['continue-icon']} icon-key-left`}
							variant='right'
							text='Continue'
						/>
					</>
				),
			}
		},
        onHidden: onHidden
    };
    const addNewSupplierProps = {
        onHidden: () => toggleAddSlider(false),
        supplierName: searchVal,
        saveCB: (data) => {
            var {addedSuppliers, addedIds} = selectSupplier(data, true);
            var data = {
                supKeys: addedIds,
                supData: addedSuppliers
            };
            onContinue(data);
        }
    }
    const leftIconArr = [{
        className: 'icon-HDRback',
        onClick: () => {
            historyHandler.closeCurrent();
        }
    }];
    const rightIconArr = [{
        className: 'icon-HDRcross',
        onClick: () => {
            historyHandler.closeAll();
        }
    }];
    const tabData = {
        tabs: [{ value: 'Add Supplier' }, { value: 'View Selected' }],
        onTabChange: (index) => {
            setActiveTab(index)
        },
    };
    const onInputChange = (e) => {
        setSearchLoader(true);
        if(debounceTimeout){
            clearTimeout(debounceTimeout);
        }
        setSearchVal(e.target.value);
        var url = '/marketplace/purchaseorder/ajax/service/getAllVendor.service?supplierId='+supplierId+'&showJdResults=false&currentPage=1&searchKey='+e.target.value+'&pageSize=20&module=manageProduct';
        const timeOutId = setTimeout(() => {
            axios.get(url).then(res => {
                var list = res.data;
                setSuggestions(list.data);
                setSearchLoader(false);
            })
        }, 300)
        setDebTimeout(timeOutId);
    }
    var headerProps = {
        heading: 'Select Supplier',
        leftIcons: leftIconArr,
        rightIcons: rightIconArr,
        searchBox: !activeTab,
        searchVariant: 'edit',
        inputProps: {
            val: searchVal,
            placeholder: 'Search Supplier',
            onChange: onInputChange,
            onClear: () => setSearchVal(''),
            isSearchLoading: searchLoader,
        },
        tabData,
        activeTab
    };
    const selectSupplier = (supplier, returnData) => {
        var tempList = [...supplierList];
        var tempIds = [...supplierIdsList];
        tempIds.push(supplier.vendorMongoId);
        tempList.push(supplier);
        setSupplierList(tempList);
        setSupplierIdsList(tempIds);
        if(returnData){
            return({
                addedSuppliers: tempList,
                addedIds: tempIds
            })
        }
    }
    const removeSupplier = (index) => {
        var tempList = [...supplierList];
        var tempIds = [...supplierIdsList];
        tempIds.splice(index, 1);
        tempList.splice(index, 1);
        setSupplierList(tempList);
        setSupplierIdsList(tempIds);
    }
    const selectUnselect = (ele) => {
        var index = supplierIdsList.indexOf(ele.vendorMongoId);
        if(index > -1){
            removeSupplier(index);
        }else{
            selectSupplier(ele);
        }
    }
    const createNewSup = () => {
        toggleAddSlider(true);
    }
    const getAreaCity = (supplier) => {
        var address = {
            area: '',
            city: ''
        };
        if(supplier && Object.keys(supplier).length) {
            if(supplier.hasOwnProperty('vendorAddress')) {
                address = {
                    ...supplier.vendorAddress[0]
                };
            }
            if(supplier.hasOwnProperty('address')){
                address = {
                    ...supplier.address[0]
                };
            }
            
        }
        
        return address?.area ? address.area+' - '+address.city : address.city;
    }
    const CreateNew = withRipple((props) => {
        return (
            <div className={style['supplier-holder'] + ' ' + style['create-new-holder'] +" "+props.rippleClass} {...props.rippleHandler} onClick={createNewSup}>
                <div className={`left-icon ${style['left-icon']}`}>
                    <span className="icon-plus"></span>
                </div>
                <div>
                    <div>{searchVal}</div>
                    <div className={style["create-new-label"]}>CREATE NEW SUPPLIER</div>
                </div>
                {props.renderRipple()}
            </div>
        )
    });
    const ItemList = withRipple((props) => {
        const {ele} = props;
        var selected = supplierIdsList.indexOf(ele.vendorMongoId) > -1;
        return (
            <div className={style['supplier-holder'] + ' ' +(selected ? style['selected'] : '')+props.rippleClass} {...props.rippleHandler} onClick={() => selectUnselect(ele)}>
                <FormCheck 
                    rippleColor='rgba(33, 37, 41, .1)'
                    onChange={(e) => {}}
                    checked={selected}
                    type='circle'
                    className={style['supplier-cb']}
                />
                <div className={style["supplier-name"]}>
                    <SearchText 
                        text={ele.nickName || ele.companyName}
                        search={searchVal}
                        className={`${style['fs-sb']} ${style['width100Per']}`}
                        highlightClass={style['font400']}
                    />
                    <div className={style["supplier-addr"]}>{getAreaCity(ele)}</div>
                </div>
                {props.renderRipple()}
            </div>
        )
    });
    const SelectedSuppliers = (props) => {
        return (
            supplierList.length ? 
                supplierList.map((cur, index) => (
                    <div key={'supList'+index} className={style['supplier-holder']}>
                        <div className={`${style['supplier-icon']} ${style['mgr-15']} ${style['icon-Home']} icon-Home`}></div>
                        <div className={style["supplier-name"]}>
                            <div className={style["width100Per"]}>{cur.nickName || cur.companyName}</div>
                            <div className={style["supplier-addr"]}>{getAreaCity(cur)}</div>
                            <div className={style["cross-icon"]} onClick={() => removeSupplier(index)}>
                                <span className='icon-HDRcross'></span>
                            </div>
                        </div>
                    </div>
                )) : 
                <div className={style['no-supplier-section']}>
                    <div>
                        <img className={style['supplier-img']} src="https://image1.jdomni.in/jdomni_email/emptySupplier_1903251516.png" />
                    </div>
                    <div className={style['supplier-text']}>No Suppliers Selected</div>
                </div>
        )
    };
    return (
        <>
        <SliderWrapper {...sliderProps} >
            <SliderHeader {...headerProps} />
            {!activeTab && searchVal ? 
                <>
                    <CreateNew />
                    {suggestions.map((ele, index) => (
                        <ItemList ele={ele} />
                    ))}
                </> : 
                null
            }
            {activeTab ? <SelectedSuppliers /> : null}
        </SliderWrapper>
        {addSlider ? <AddNewSupplier {...addNewSupplierProps} /> : null}
        </>
    );
}
const mapStateToProps = state => {
    return {
        supplierId: state.session.supplierId
    };
};
export default connect(mapStateToProps, {
    showToastMessage: toastMessageActions.showMessage
})(SelectSupplierSlider)